import { createAction } from 'redux-act';

export const getPlans = createAction('get plans');
export const setPlans = createAction('set plans');
export const updatePlan = createAction('update plan');
export const setUpdatedPlans = createAction('set Updated Plans');
